export default "__VITE_PUBLIC_ASSET__82501c3d__"